import type { AdminStatus, UserAccountStatus } from "../../types/orders";

const STATUS_STYLES: Record<AdminStatus, string> = {
  Order: "bg-bg-secondary text-text-secondary",
  Registered: "bg-brand-brown-6 text-brand-brown",
  "Sample Collected": "bg-brand-brown-6 text-brand-brown",
  "Sample Received at Lab": "bg-brand-brown-6 text-brand-brown",
  "Results Received": "bg-[rgba(118,151,124,0.08)] text-[#76977c]",
  "Report Published": "bg-[rgba(118,151,124,0.08)] text-[#76977c]",
};

export function KitStatusBadge({ status }: Readonly<{ status: AdminStatus }>) {
  const style = STATUS_STYLES[status] ?? "bg-bg-secondary text-text-secondary";
  return (
    <span className={`inline-block px-3 py-1.5 rounded-full text-sm whitespace-nowrap ${style}`}>
      {status}
    </span>
  );
}

const ACCOUNT_STYLES: Record<UserAccountStatus, string> = {
  Completed: "bg-[rgba(118,151,124,0.08)] text-[#76977c]",
  "Not registered": "bg-bg-secondary text-text-secondary",
  "Need to Complete": "bg-brand-brown-6 text-brand-brown",
};

export function UserAccountBadge({ status }: Readonly<{ status: UserAccountStatus }>) {
  const style = ACCOUNT_STYLES[status] ?? "bg-bg-secondary text-text-secondary";
  return (
    <span className={`inline-block px-3 py-1.5 rounded-full text-sm whitespace-nowrap ${style}`}>
      {status}
    </span>
  );
}

// Results Received tab has its own status chips derived from assignment state
export type ResultsStatus = "Awaiting Assignment" | "Awaiting Review" | "Draft Created";

const RESULTS_STATUS_STYLES: Record<ResultsStatus, string> = {
  "Awaiting Assignment": "bg-[rgba(118,151,124,0.08)] text-[#76977c]",
  "Awaiting Review": "bg-brand-brown-6 text-brand-brown",
  "Draft Created": "bg-bg-secondary text-text-tertiary",
};

export function ResultsStatusBadge({ status }: Readonly<{ status: ResultsStatus }>) {
  const style = RESULTS_STATUS_STYLES[status] ?? "bg-bg-secondary text-text-secondary";
  return (
    <span className={`inline-block px-3 py-1.5 rounded-full text-sm whitespace-nowrap ${style}`}>
      {status}
    </span>
  );
}
